import React from 'react';
import useRedirectAppSport from 'hooks/useRedirectAppSport';

export const RedirectAppSport = () => {
  useRedirectAppSport();
  return <React.Fragment key={'app-sport-redirect'} />;
};
